// Variables globales
let currentStep = 1;
const totalSteps = 6;
let formData = {};
let formResults = {};
let overallResult = 'APTO';

// Variables para los selectores visuales
let mattressProblems = {
    zonasamarillentas: [],
    manchas: [],
    hundimiento: []
};

// Inicialización cuando se carga la página
document.addEventListener('DOMContentLoaded', function() {
    initializeForm();
    setupFormValidation();
    setupMattressGrid();
    updateProgressBar();
    
    // Auto-completar fecha actual
    const today = new Date().toISOString().split('T')[0];
    document.getElementById('fechadia').value = today;
    
    // Auto-completar hora actual
    const now = new Date();
    const currentTime = now.getHours().toString().padStart(2, '0') + ':' + 
                       now.getMinutes().toString().padStart(2, '0');
    document.getElementById('horadia').value = currentTime;
});

// Inicializar el formulario
function initializeForm() {
    // Mostrar solo el primer paso
    showStep(1);
    
    // Configurar el evento de envío del formulario
    document.getElementById('colchonForm').addEventListener('submit', handleFormSubmit);
}

// Actualizar barra de progreso
function updateProgressBar() {
    const progress = (currentStep / totalSteps) * 100;
    const progressFill = document.getElementById('progressFill');
    const progressText = document.getElementById('progressText');
    
    if (progressFill && progressText) {
        progressFill.style.width = `${progress}%`;
        progressText.textContent = `${Math.round(progress)}%`;
    }
}

// Navegar al siguiente paso
function nextStep() {
    if (validateCurrentStep()) {
        saveCurrentStepData();
        if (currentStep < totalSteps) {
            showStep(currentStep + 1);
        }
    } else {
        showValidationErrors();
    }
}

// Navegar al paso anterior
function prevStep() {
    if (currentStep > 1) {
        showStep(currentStep - 1);
    }
}

// Validar el paso actual (sin campos required - siempre válido)
function validateCurrentStep() {
    // Limpiar errores previos
    clearValidationErrors();
    
    // Siempre retorna true para permitir avanzar
    return true;
}

// Validar un campo individual (solo validaciones de formato, no obligatoriedad)
function validateField(field) {
    const value = field.value.trim();
    const fieldType = field.type;
    
    // Solo validar formato si hay contenido
    if (!value) {
        markFieldAsValid(field);
        return true;
    }
    
    // Validaciones específicas por tipo
    switch (fieldType) {
        case 'email':
            if (!isValidEmail(value)) {
                markFieldAsInvalid(field);
                return false;
            }
            break;
            
        case 'tel':
            if (!isValidPhone(value)) {
                markFieldAsInvalid(field);
                return false;
            }
            break;
            
        case 'date':
            if (!isValidDate(value)) {
                markFieldAsInvalid(field);
                return false;
            }
            break;
    }
    
    markFieldAsValid(field);
    return true;
}

// Marcar campo como inválido
function markFieldAsInvalid(field) {
    field.classList.add('invalid');
    field.classList.remove('valid');
}

// Marcar campo como válido
function markFieldAsValid(field) {
    field.classList.add('valid');
    field.classList.remove('invalid');
}

// Limpiar errores de validación
function clearValidationErrors() {
    const fields = document.querySelectorAll('.invalid');
    fields.forEach(field => {
        field.classList.remove('invalid');
    });
}

// Mostrar errores de validación (solo para formato)
function showValidationErrors() {
    const firstInvalidField = document.querySelector('.invalid');
    if (firstInvalidField) {
        firstInvalidField.focus();
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showTemporaryMessage('Revisa el formato de los campos marcados', 'warning');
    }
}

// Mostrar mensaje temporal
function showTemporaryMessage(message, type = 'info') {
    // Crear elemento del mensaje si no existe
    let messageElement = document.getElementById('temporaryMessage');
    if (!messageElement) {
        messageElement = document.createElement('div');
        messageElement.id = 'temporaryMessage';
        messageElement.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            padding: 15px 20px;
            border-radius: 6px;
            color: white;
            font-weight: 500;
            z-index: 1000;
            transform: translateX(400px);
            transition: transform 0.3s ease;
        `;
        document.body.appendChild(messageElement);
    }
    
    // Configurar estilos según el tipo
    const colors = {
        error: '#e74c3c',
        success: '#27ae60',
        warning: '#f39c12',
        info: '#3498db'
    };
    
    messageElement.style.backgroundColor = colors[type] || colors.info;
    messageElement.textContent = message;
    
    // Mostrar mensaje
    setTimeout(() => {
        messageElement.style.transform = 'translateX(0)';
    }, 100);
    
    // Ocultar mensaje después de 3 segundos
    setTimeout(() => {
        messageElement.style.transform = 'translateX(400px)';
        setTimeout(() => {
            if (messageElement.parentNode) {
                messageElement.parentNode.removeChild(messageElement);
            }
        }, 300);
    }, 3000);
}

// Guardar datos del paso actual
function saveCurrentStepData() {
    const currentStepElement = document.getElementById(`step${currentStep}`);
    const inputs = currentStepElement.querySelectorAll('input, select, textarea');
    
    inputs.forEach(input => {
        if (input.type === 'checkbox') {
            if (!formData[input.name]) {
                formData[input.name] = [];
            }
            if (input.checked) {
                if (!formData[input.name].includes(input.value)) {
                    formData[input.name].push(input.value);
                }
            } else {
                const index = formData[input.name].indexOf(input.value);
                if (index > -1) {
                    formData[input.name].splice(index, 1);
                }
            }
        } else if (input.type === 'radio') {
            if (input.checked) {
                formData[input.name] = input.value;
            }
        } else {
            formData[input.name] = input.value;
        }
    });
    
    // Guardar datos específicos del colchón si estamos en el paso 4
    if (currentStep === 4) {
        updateHiddenInputs();
        formData.mattressProblems = { ...mattressProblems };
    }
}

// Configurar validación en tiempo real (solo formato)
function setupFormValidation() {
    const inputs = document.querySelectorAll('input, select, textarea');
    
    inputs.forEach(input => {
        // Validación en tiempo real mientras se escribe
        input.addEventListener('input', function() {
            if (this.value.trim()) {
                validateField(this);
            } else {
                // Si está vacío, marcarlo como válido
                markFieldAsValid(this);
            }
        });
        
        // Validación al perder el foco
        input.addEventListener('blur', function() {
            if (this.value.trim()) {
                validateField(this);
            }
        });
        
        // Para radio buttons y checkboxes
        if (input.type === 'radio' || input.type === 'checkbox') {
            input.addEventListener('change', function() {
                validateField(this);
            });
        }
    });
}

// Manejar envío del formulario
function handleFormSubmit(e) {
    e.preventDefault();
    
    // Validar solo formato, no obligatoriedad
    validateCurrentStep();
    
    // Guardar datos del último paso
    saveCurrentStepData();
    
    // Mostrar pantalla de carga
    showLoadingScreen();
    
    // Después de 3 segundos, mostrar resultados
    setTimeout(() => {
        generateAndShowResults();
    }, 3000);
}

// Mostrar pantalla de carga
function showLoadingScreen() {
    document.getElementById('colchonForm').style.display = 'none';
    document.querySelector('.progress-container').style.display = 'none';
    document.querySelector('.form-header').style.display = 'none';
    document.getElementById('loadingContainer').style.display = 'block';
}

// Generar y mostrar resultados
function generateAndShowResults() {
    // Ocultar pantalla de carga
    document.getElementById('loadingContainer').style.display = 'none';
    
    // Copiar formData a formResults para compatibilidad
    formResults = { ...formData };
    
    // Generar resultados
    generateResults();
    
    // Mostrar contenedor de resultados
    document.getElementById('resultsContainer').style.display = 'block';
}

// Reiniciar formulario
function restartForm() {
    // Limpiar datos
    formData = {};
    formResults = {};
    mattressProblems = {
        zonasamarillentas: [],
        manchas: [],
        hundimiento: []
    };
    overallResult = 'APTO';
    
    // Limpiar formulario
    document.getElementById('colchonForm').reset();
    
    // Ocultar resultados
    document.getElementById('resultsContainer').style.display = 'none';
    
    // Mostrar formulario y header
    document.getElementById('colchonForm').style.display = 'block';
    document.querySelector('.progress-container').style.display = 'block';
    document.querySelector('.form-header').style.display = 'block';
    
    // Volver al paso 1
    showStep(1);
}

// Funciones de validación auxiliares
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function isValidPhone(phone) {
    const phoneRegex = /^[0-9()#+*\-=.\s]+$/;
    return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 9;
}

function isValidDate(dateString) {
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date);
}

// ========== FUNCIONES PARA LOS GRIDS VISUALES ==========

// Configurar los grids interactivos del colchón
function setupMattressGrid() {
    // Configurar cada grid individual
    setupIndividualGrid('mattressGrid1', 'zonasamarillentas');
    setupIndividualGrid('mattressGrid2', 'manchas');
    setupIndividualGrid('mattressGrid3', 'hundimiento');
}

// Configurar un grid individual
function setupIndividualGrid(gridId, problemType) {
    const gridItems = document.querySelectorAll(`#${gridId} .grid-item`);
    gridItems.forEach(item => {
        item.addEventListener('click', function() {
            const zone = this.dataset.zone;
            toggleZoneProblem(zone, problemType);
            updateGridVisual(gridId, problemType);
            updateZonesSummary();
            updateHiddenInputs();
        });
    });
}

// Alternar problema en una zona
function toggleZoneProblem(zone, problemType) {
    const problemArray = mattressProblems[problemType];
    const zoneIndex = problemArray.indexOf(zone);
    
    if (zoneIndex > -1) {
        // Si ya existe, lo removemos
        problemArray.splice(zoneIndex, 1);
    } else {
        // Si no existe, lo agregamos
        problemArray.push(zone);
    }
}

// Actualizar la visualización de un grid específico
function updateGridVisual(gridId, problemType) {
    const gridItems = document.querySelectorAll(`#${gridId} .grid-item`);
    
    gridItems.forEach(item => {
        const zone = item.dataset.zone;
        
        // Remover clase selected
        item.classList.remove('selected');
        
        // Agregar clase selected si la zona está en el array de problemas
        if (mattressProblems[problemType].includes(zone)) {
            item.classList.add('selected');
        }
    });
}

// Actualizar el resumen de zonas
function updateZonesSummary() {
    const summaryAmarillentas = document.getElementById('summaryAmarillentas');
    const summaryManchas = document.getElementById('summaryManchas');
    const summaryHundimiento = document.getElementById('summaryHundimiento');
    
    if (summaryAmarillentas) {
        summaryAmarillentas.textContent = mattressProblems.zonasamarillentas.length > 0 
            ? mattressProblems.zonasamarillentas.sort((a, b) => parseInt(a) - parseInt(b)).join(', ')
            : 'Ninguna';
    }
    
    if (summaryManchas) {
        summaryManchas.textContent = mattressProblems.manchas.length > 0 
            ? mattressProblems.manchas.sort((a, b) => parseInt(a) - parseInt(b)).join(', ')
            : 'Ninguna';
    }
    
    if (summaryHundimiento) {
        summaryHundimiento.textContent = mattressProblems.hundimiento.length > 0 
            ? mattressProblems.hundimiento.sort((a, b) => parseInt(a) - parseInt(b)).join(', ')
            : 'Ninguna';
    }
}

// Actualizar los inputs ocultos con los datos
function updateHiddenInputs() {
    const zonasamarillentasInput = document.getElementById('zonasamarillentas');
    const manchasInput = document.getElementById('manchas');
    const hundimientoInput = document.getElementById('hundimiento');
    
    if (zonasamarillentasInput) {
        zonasamarillentasInput.value = mattressProblems.zonasamarillentas.join(',');
    }
    
    if (manchasInput) {
        manchasInput.value = mattressProblems.manchas.join(',');
    }
    
    if (hundimientoInput) {
        hundimientoInput.value = mattressProblems.hundimiento.join(',');
    }
}

// Mostrar un paso específico
function showStep(step) {
    // Ocultar todos los pasos
    const allSteps = document.querySelectorAll('.form-step');
    allSteps.forEach(stepElement => {
        stepElement.classList.remove('active');
    });
    
    // Mostrar el paso actual
    const currentStepElement = document.getElementById(`step${step}`);
    if (currentStepElement) {
        currentStepElement.classList.add('active');
    }
    
    currentStep = step;
    updateProgressBar();
    
    // Scroll al top
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ========== FUNCIONES PARA GENERAR RESULTADOS ==========

// Generar todos los resultados
function generateResults() {
    generateMattressInfo();
    generateVisualTest();
    generateFirmnessTest();
    generateHygieneTest();
    generateRecommendation();
    updateWelcomeTitle();
}

// Generar información del colchón
function generateMattressInfo() {
    const hasMattressInfo = formResults.tipocolchon || formResults.antiguedadcolchon;
    
    if (!hasMattressInfo) return;

    const section = document.getElementById('mattressInfoSection');
    section.style.display = 'block';

    // Tipo de colchón
    if (formResults.tipocolchon) {
        document.getElementById('mattressType').textContent = formResults.tipocolchon;
    } else {
        document.getElementById('mattressType').innerHTML = '<span class="no-data">No especificado</span>';
    }

    // Antigüedad
    if (formResults.antiguedadcolchon) {
        document.getElementById('mattressAge').textContent = formResults.antiguedadcolchon;
    } else {
        document.getElementById('mattressAge').innerHTML = '<span class="no-data">No especificada</span>';
    }
}

// Generar resultados de prueba visual
function generateVisualTest() {
    const hasVisualData = formResults.zonasamarillentas || formResults.manchas || 
                         formResults.hundimiento || formResults.validezvisual;
    
    if (!hasVisualData) return;

    const section = document.getElementById('visualTestSection');
    section.style.display = 'block';

    // Zonas amarillentas (hongos)
    if (formResults.zonasamarillentas) {
        const hongosZones = formResults.zonasamarillentas.split(',').filter(zone => zone.trim());
        if (hongosZones.length > 0) {
            document.getElementById('hongosSection').style.display = 'block';
            const gridItems = document.querySelectorAll('#hongosGrid .grid-item-result');
            gridItems.forEach(item => {
                const zone = item.dataset.zone;
                if (hongosZones.includes(zone)) {
                    item.classList.add('selected');
                }
            });
        }
    }

    // Manchas
    if (formResults.manchas) {
        const manchasZones = formResults.manchas.split(',').filter(zone => zone.trim());
        if (manchasZones.length > 0) {
            document.getElementById('manchasSection').style.display = 'block';
            const gridItems = document.querySelectorAll('#manchasGrid .grid-item-result');
            gridItems.forEach(item => {
                const zone = item.dataset.zone;
                if (manchasZones.includes(zone)) {
                    item.classList.add('selected');
                }
            });
        }
    }

    // Hundimientos
    if (formResults.hundimiento) {
        const hundimientoZones = formResults.hundimiento.split(',').filter(zone => zone.trim());
        if (hundimientoZones.length > 0) {
            document.getElementById('hundimientoSection').style.display = 'block';
            const gridItems = document.querySelectorAll('#hundimientoGrid .grid-item-result');
            gridItems.forEach(item => {
                const zone = item.dataset.zone;
                if (hundimientoZones.includes(zone)) {
                    item.classList.add('selected');
                }
            });
        }
    }

    // Validez visual
    if (formResults.validezvisual) {
        const validityElement = document.getElementById('visualValidity');
        validityElement.textContent = formResults.validezvisual;
        validityElement.className = `result-value ${formResults.validezvisual === 'APTO' ? 'apto' : 'no-apto'}`;
        
        if (formResults.validezvisual === 'NO APTO') {
            overallResult = 'NO APTO';
        }
    } else {
        document.getElementById('visualValidity').innerHTML = '<span class="no-data">No evaluado</span>';
    }
}

// Generar resultados de prueba de firmeza
function generateFirmnessTest() {
    const hasFirmnessData = formResults.firmezacolchon || formResults.validezfirmeza;
    
    if (!hasFirmnessData) return;

    const section = document.getElementById('firmnessTestSection');
    section.style.display = 'block';

    // Estado actual de firmeza
    if (formResults.firmezacolchon) {
        const firmness = formResults.firmezacolchon;
        document.getElementById('currentFirmness').innerHTML = `<strong>${firmness}</strong>`;
        
        // Agregar descripción según la firmeza
        const descriptions = {
            'Muy firme': 'El colchón mantiene una firmeza muy alta.',
            'Firme': 'Firme',
            'Poco firme': 'El colchón ha perdido firmeza con el tiempo.',
            'Deformado': 'El colchón presenta deformaciones significativas.'
        };
        
        if (descriptions[firmness]) {
            const description = document.createElement('div');
            description.style.fontSize = '1.1rem';
            description.style.color = '#555';
            description.style.marginTop = '10px';
            description.style.fontWeight = '500';
            description.textContent = descriptions[firmness];
            document.getElementById('currentFirmness').appendChild(description);
        }
        
        // Siempre agregar el texto recomendado después
        const recommendedText = document.createElement('div');
        recommendedText.style.fontSize = '1.1rem';
        recommendedText.style.color = '#555';
        recommendedText.style.marginTop = '10px';
        recommendedText.style.fontWeight = '500';
        recommendedText.textContent = 'Lo recomendable es mantener una firmeza adecuada en el colchón para poder descansar mejor.';
        document.getElementById('currentFirmness').appendChild(recommendedText);
    } else {
        document.getElementById('currentFirmness').innerHTML = '<span class="no-data">No especificado</span>';
    }

    // Validez de firmeza
    if (formResults.validezfirmeza) {
        const validityElement = document.getElementById('firmnessValidity');
        validityElement.textContent = formResults.validezfirmeza;
        validityElement.className = `result-value ${formResults.validezfirmeza === 'APTO' ? 'apto' : 'no-apto'}`;
        
        if (formResults.validezfirmeza === 'NO APTO') {
            overallResult = 'NO APTO';
        }
    } else {
        document.getElementById('firmnessValidity').innerHTML = '<span class="no-data">No evaluado</span>';
    }
}

// Generar resultados de prueba de higiene
function generateHygieneTest() {
    const hasHygieneData = formResults.polvoacaros || formResults.validezhigiene;
    
    if (!hasHygieneData) return;

    const section = document.getElementById('hygieneTestSection');
    section.style.display = 'block';

    // Resultado de la prueba con colores
    if (formResults.polvoacaros) {
        const result = formResults.polvoacaros;
        const descriptions = {
            'BLANCO': 'BLANCO (Óptimas condiciones)',
            'GRIS CLARO': 'GRIS CLARO (Mantenimiento recomendado)',
            'GRIS OSCURO': 'GRIS OSCURO (Recomendación de cambio)',
            'NEGRO': 'NEGRO (Uso no recomendado)'
        };
        
        const displayText = descriptions[result] || result;
        
        // Crear texto descriptivo más grande sin clases de color
        const hygieneDescription = document.createElement('div');
        hygieneDescription.style.fontSize = '1.1rem';
        hygieneDescription.style.color = '#555';
        hygieneDescription.style.marginTop = '10px';
        hygieneDescription.style.fontWeight = '500';
        hygieneDescription.innerHTML = `Respecto a la prueba de higiene, las opciones eran <strong>BLANCO</strong>, <strong>GRIS CLARO</strong>, <strong>GRIS OSCURO</strong> o <strong>NEGRO</strong>. El resultado de tu prueba ha sido <strong>${displayText}</strong>.`;
        
        document.getElementById('hygieneResult').innerHTML = '';
        document.getElementById('hygieneResult').appendChild(hygieneDescription);
    } else {
        document.getElementById('hygieneResult').innerHTML = '<span class="no-data">No evaluado</span>';
    }

    // Validez de higiene
    if (formResults.validezhigiene) {
        const validityElement = document.getElementById('hygieneValidity');
        validityElement.textContent = formResults.validezhigiene;
        validityElement.className = `result-value ${formResults.validezhigiene === 'APTO' ? 'apto' : 'no-apto'}`;
        
        if (formResults.validezhigiene === 'NO APTO') {
            overallResult = 'NO APTO';
        }
    } else {
        document.getElementById('hygieneValidity').innerHTML = '<span class="no-data">No evaluado</span>';
    }
}

// Generar recomendación final
function generateRecommendation() {
    const recommendationSection = document.getElementById('recommendationSection');
    const titleElement = document.getElementById('recommendationTitle');
    const textElement = document.getElementById('recommendationText');

    // Aplicar siempre el mismo estilo neutro
    recommendationSection.className = 'recommendation';

    if (overallResult === 'NO APTO') {
        // Resultado NO APTO
        titleElement.textContent = 'Si has tenido como resultado uno o más resultados No aptos, te recomendamos que cambies de colchón.';
        textElement.innerHTML = 'Al dar resultado <strong>No Apto</strong>, tras la valoración del protocolo de actuación, el colchón no pasaría el Control de Calidad. Por ello, te ha sido aprobada la solicitud del <strong><em>Plan Renove</em></strong> para tu colchón.';
    } else {
        // Resultado APTO
        titleElement.textContent = '¡Felicidades! Tu colchón está en buenas condiciones.';
        textElement.textContent = 'Según la evaluación realizada, tu colchón cumple con los estándares de calidad y puede continuar proporcionándote un descanso adecuado.';
    }
}

// Actualizar título de bienvenida con el nombre si está disponible
function updateWelcomeTitle() {
    const welcomeTitle = document.getElementById('welcomeTitle');
    const nombre = formResults.nombre;
    
    if (nombre && nombre.trim()) {
        welcomeTitle.textContent = `¡Muchas gracias, ${nombre.trim()}!`;
    } else {
        welcomeTitle.textContent = '¡Muchas gracias!';
    }
}